import { IconProps } from "typing";
import { theme } from "../themes";

export const MyDataIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
  testId = "my-data-icon",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      data-testid={testId}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.4069 12.1768V13.0101"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9069 12.1768V13.0101"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.834 5.94792H15.0111"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41667 5.53125V6.36458"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91667 5.53125V6.36458"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.5"
        y="2.60449"
        width="15"
        height="6.66667"
        rx="1.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16667 15.9372H3.75C3.05964 15.9372 2.5 15.3775 2.5 14.6872V10.5205C2.5 9.83015 3.05964 9.27051 3.75 9.27051"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0857 14.9697L11.895 16.1638C11.7487 16.3113 11.6664 16.5105 11.666 16.7183V17.5492C11.666 17.9824 12.0172 18.3336 12.4504 18.3337H13.2849C13.4931 18.3339 13.6928 18.2508 13.8394 18.1029L15.0261 16.9128"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.087 14.9691C12.7976 13.806 13.3196 12.5928 14.363 12.0032C15.4065 11.4137 16.7151 11.5926 17.5619 12.4407C18.4088 13.2887 18.5859 14.5976 17.9949 15.6402C17.4039 16.6828 16.19 17.2032 15.0273 16.9121"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7083 14.3337C15.7083 14.3567 15.6896 14.3753 15.6666 14.3753C15.6436 14.3753 15.625 14.3567 15.625 14.3337C15.625 14.3107 15.6436 14.292 15.6666 14.292C15.6777 14.292 15.6883 14.2964 15.6961 14.3042C15.704 14.312 15.7084 14.3226 15.7083 14.3337"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
